import React from "react"

// Domain-neutral: callers pass the two site objects ({ url, label }) in the
// order they should appear ("this" site first), so the same markup serves both
// NYP and RODG.
const SiteLink = ({ site }) => (
  <a href={site.url} target="_blank" rel="noopener noreferrer">
    {site.label}
  </a>
)

export const AccountCrossSiteNote = ({ primarySite, secondarySite }) => (
  <>
    Same account works for both
    <br />
    <SiteLink site={primarySite} /> and <SiteLink site={secondarySite} />
  </>
)

export const PremiumCrossSiteNote = ({ primarySite, secondarySite }) => (
  <>
    One pass unlocks premium on both <SiteLink site={primarySite} /> and <SiteLink site={secondarySite} />.
  </>
)
